module.exports = __webpack_public_path__ + "img/moneyout.a8ecb50b.png";